﻿import { Modal } from "./_modal";
import * as Res from "./res";
import { createElement } from "./_dom";
import { loadGoogleMapApiAsync, getCurrentPositionAsync } from "./googlemap";
import { registerComponent } from "./component";

function getSpinner() {
	const spinner = createElement('div', {
			class: 'v3-map-spinner',
			style: {
				position: "absolute",
				left: "50%",
				top: "50%",
				"margin-top": "-30px",
				"margin-left": "-30px"
			}
		},
		createElement("div", { class: "v3-spinner-big" }, createElement("div"))
	);
	return spinner;
}

/** @param {HTMLInputElement} input */
function fixMisplacedDropdownPosition(input) {
	const fixPosition = () => setTimeout(() => {
		document.querySelectorAll(".pac-container").forEach(autoCompleteDropdown => {
			if (window.getComputedStyle(autoCompleteDropdown).display !== "none") { // visible
				const inputRect = input.getBoundingClientRect();
				const left = inputRect.left;
				const top = inputRect.bottom;
				autoCompleteDropdown.style.position = "fixed";
				autoCompleteDropdown.style.left = `${left}px`;
				autoCompleteDropdown.style.top = `${top}px`;
			}
		});
	}, 100);
	input.addEventListener("input", fixPosition);
	input.addEventListener("focus", fixPosition);
}

async function initMap(mapDialog, googleMaps, latLng, locationInput, options = { zoom: 17, type: "roadmap" }) {
	if (!latLng) {
		latLng = await getCurrentPositionAsync();
	}
	const { zoom, type } = options;
	const map = new googleMaps.Map(document.getElementById('map'), {
		center: latLng,
		zoom: zoom,
		streetViewControl: false,
		zoomControl: true,
		mapTypeId: type || googleMaps.MapTypeId.ROADMAP,
		mapTypeControl: true,
		mapTypeControlOptions: {
			position: googleMaps.ControlPosition.TOP_RIGHT,
			style: googleMaps.MapTypeControlStyle.DROPDOWN_MENU,
			mapTypeIds: ["roadmap", "terrain", "satellite", "hybrid"]
		}
	});
	const geocoder = new googleMaps.Geocoder();
	const marker = new googleMaps.Marker({
		position: latLng,
		map,
		draggable: true,
	});
	const input = createElement("input", {
		class: "v3-map-input v3-input",
		placeholder: Res.getString('location.search')
	});
	const searchBox = createElement('div', { class: "v3-search-box" }, input);
	const autocomplete = new googleMaps.places.Autocomplete(input);
	autocomplete.bindTo("bounds", map);

	fixMisplacedDropdownPosition(input);

	map.controls[googleMaps.ControlPosition.TOP_LEFT].push(searchBox);

	autocomplete.addListener("place_changed", () => {
		marker.setVisible(false);

		const place = autocomplete.getPlace();

		if (!place.geometry || !place.geometry.location) {
			return;
		}

		if (place.geometry.viewport) {
			map.fitBounds(place.geometry.viewport);
		} else {
			map.setCenter(place.geometry.location);
			map.setZoom(17);
		}

		marker.setPosition(place.geometry.location);
		marker.setVisible(true);
	});

	marker.addListener('dragend', () => {
		geocoder.geocode({ 'latLng': marker.getPosition() }, function (results, status) {
			if (status === googleMaps.GeocoderStatus.OK) {
				input.value = results[0].formatted_address;
			}
		});
	});


	const saveButton = createElement('button', {
			type: "button",
			class: "v3-button v3-button-location-save",
		},
		Res.getString("action.save"));

	const cancelButton = createElement('button', {
			type: "button",
			class: "v3-button v3-button-location-cancel"
		},
		Res.getString("action.cancel"));

	const controls = createElement('div', { class: "v3-map-controls v3-buttonbar" },
		saveButton,
		cancelButton
	);

	map.controls[googleMaps.ControlPosition.BOTTOM_LEFT].push(controls);

	saveButton.addEventListener('click', () => {
		if (marker) {
			const latlng = marker.getPosition();
			const newValue = `${latlng.lat().toFixed(6)}, ${latlng.lng().toFixed(6)}`;
			if (input.value != newValue) {
				locationInput.value = newValue;
				locationInput.dispatchEvent(new Event('change', { bubbles: true }));
			}
		}
		mapDialog.removeModal();
	});
	cancelButton.addEventListener('click', () => {
		mapDialog.removeModal();
	});
}

async function setCurrentLocation(input, loadButton) {
	try {
		loadButton.classList.add('ui-icon-spinner');
		const { lat, lng } = await getCurrentPositionAsync();
		loadButton.classList.remove('ui-icon-spinner');
		const newValue = `${lat.toFixed(6)}, ${lng.toFixed(6)}`;
		if (input.value != newValue) {
			input.value = newValue;
			input.dispatchEvent(new Event('change', { bubbles: true }));
		}
	} catch (e) {
		loadButton.classList.remove('ui-icon-spinner');
		alert(e.message);
	}
}

function round(value) {
	var r = 1000000;
	return Math.round(value * r) / r;
}

function parseLocation(value) {
	// parse dms
	if (/^\s*$/.exec(value))
		return null;
	var m = /^\s*(\d+)\s*°(?:\s*(\d+)\s*['′])?(?:\s*(\d+(?:\.\d+)?)\s*["″])?\s*([NS])(?:(?:\s*[,;]\s*)|\s+)(\d+)\s*°(?:\s*(\d+)\s*['′])?(?:\s*(\d+(?:\.\d+)?)\s*["″])?\s*([EW])\s*$/i.exec(value);
	if (m) {
		return {
			lat: round((m[1] * 1 + (m[2] || 0) / 60 + (m[3] || 0) / 3600) * (m[4].toUpperCase() == "N" ? 1 : -1)),
			lng: round((m[5] * 1 + (m[6] || 0) / 60 + (m[7] || 0) / 3600) * (m[8].toUpperCase() == "E" ? 1 : -1))
		};
	}
	// parse degrees
	m = /^\s*(-?\d+(?:\.\d+)?)(?:(?:\s*[,;]\s*)|\s+)(-?\d+(?:\.\d+)?)\s*$/.exec(value);
	if (m) {
		return {
			lat: round(m[1] * 1),
			lng: round(m[2] * 1)
		};
	}
	// undefined = error
}

async function displayModalMap(input) {
	const modalContent = createElement('div', { id: "map", class: "v3-google-map-container" });
	const mapDialog = new Modal(modalContent).start();
	const modal = mapDialog.element;
	const spinner = getSpinner();
	modal.append(spinner);
	const googleMaps = await loadGoogleMapApiAsync(["marker", "places"]);
	spinner.remove();
	const coord = parseLocation(input.value);
	let options;
	try { options = JSON.parse(input.dataset.options); } catch { };
	await initMap(mapDialog, googleMaps, coord, input, options);
}

function createLocationControl(input) {
	const parent = input.parentNode;
	const span = createElement('span', { class: "v3-location-edit v3-controlgroup focusable" },
		input,
		createElement("button", {
				type: "button",
				class: "v3-button v3-location-edit__current v3-controlgroup__item ui-icon-compass ui-icon-only",
				title: Res.getString("location.current"),
				onclick: ({ currentTarget }) => setCurrentLocation(input, currentTarget)
			},
			createElement("span", { class: "ui-icontext" }, Res.getString("location.current"))
		),
		createElement("button", {
				type: "button",
			class: "v3-button v3-location-edit__set v3-controlgroup__item-last v3-controlgroup__item ui-icon-map ui-icon-only",
				title: Res.getString("location.select"),
				onclick: () => displayModalMap(input)
			},
			createElement("span", { class: "ui-icontext" }, Res.getString("location.select"))
		)
	);
	input.classList.add("v3-location-edit__input", "v3-controlgroup__item-first", "v3-controlgroup__item");
	parent.append(span);
	if (input.classList.contains('td-use-currentlocation')) {
		const loadButton = input.parentNode.querySelector('.v3-location-edit__current');
		if (input.value === '') setCurrentLocation(input, loadButton);
	}
}

const location = registerComponent(createLocationControl);

function init(context, selector = "input.v3-input-location") {
	return location(selector, context);
}

export { location, init };
